// ============================================
// ModalReabrirExpediente.js
// ============================================
// Confirmacion simple para reabrir un expediente cerrado. Solo direccion.
// El backend (POST /:id/reabrir) limpia tipo_cierre, razon, nota, fecha_cierre.

import React, { useEffect, useState } from 'react';
import {
  API_BASE_CLI, FF, COLOR_OSCURO, COLOR_GRIS, COLOR_GRIS_CL, COLOR_BORDE,
  botonSecundario, botonPrimario, authHeaders, ShellModal, ToastFlotante,
} from './helpersExpedientes';

export default function ModalReabrirExpediente({ expediente, onCerrar, onConfirmado, esCelular }) {
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && !enviando) onCerrar(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enviando, onCerrar]);

  const confirmar = async () => {
    if (enviando) return;
    setEnviando(true);
    setError(null);
    try {
      const r = await fetch(`${API_BASE_CLI}/api/oportunidades/${expediente.id}/reabrir`, {
        method: 'POST',
        headers: { ...authHeaders() },
      });
      const data = await r.json().catch(() => ({}));
      if (r.status === 401 || r.status === 403) {
        setError('No tienes permisos (solo direccion).');
        return;
      }
      if (r.status === 409) {
        setError(data?.mensaje || 'El expediente ya esta activo.');
        return;
      }
      if (!r.ok || !data?.ok) throw new Error(data?.error || `Error ${r.status}`);
      setToast({ tipo: 'ok', msg: 'Expediente reabierto.' });
      setTimeout(() => onConfirmado(data.oportunidad), 800);
    } catch (e) {
      setError(e.message || 'No se pudo reabrir.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <ShellModal onClose={enviando ? () => {} : onCerrar} ancho={440} esCelular={esCelular}>
        <div style={{
          padding: '18px 22px', borderBottom: `1px solid ${COLOR_BORDE}`,
          display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12,
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: COLOR_OSCURO, fontFamily: FF }}>
              Reabrir expediente
            </h2>
            <div style={{ marginTop: 4, fontSize: 12, color: COLOR_GRIS_CL }}>{expediente.folio}</div>
          </div>
          <button
            onClick={onCerrar}
            disabled={enviando}
            aria-label="Cerrar"
            style={{
              background: 'transparent', border: 'none',
              cursor: enviando ? 'not-allowed' : 'pointer',
              color: COLOR_GRIS_CL, fontSize: 22, padding: 4,
            }}
          >{'×'}</button>
        </div>

        <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <p style={{ margin: 0, fontSize: 14, color: COLOR_OSCURO, lineHeight: 1.5 }}>
            ¿Reabrir este expediente?
          </p>
          <div style={{
            background: '#fef3c7', border: '1px solid #fcd34d', color: '#92400e',
            padding: '10px 12px', borderRadius: 8, fontSize: 12, lineHeight: 1.5,
          }}>
            Esta accion reactivara el expediente y limpiara la razon de cierre.
            Vuelve a quedar en estado <strong>interes</strong>.
          </div>
          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c',
              padding: '8px 12px', borderRadius: 8, fontSize: 12,
            }}>{error}</div>
          )}
        </div>

        <div style={{
          padding: 16, borderTop: `1px solid ${COLOR_BORDE}`, background: '#fafafa',
          display: 'flex', justifyContent: 'space-between', gap: 10,
        }}>
          <button onClick={onCerrar} disabled={enviando} style={botonSecundario}>Cancelar</button>
          <button
            onClick={confirmar}
            disabled={enviando}
            style={{
              ...botonPrimario,
              background: COLOR_GRIS && '#185FA5',
              opacity: enviando ? 0.5 : 1,
            }}
          >{enviando ? 'Procesando...' : 'Reabrir expediente'}</button>
        </div>
      </ShellModal>
      {toast && <ToastFlotante tipo={toast.tipo}>{toast.msg}</ToastFlotante>}
    </>
  );
}
